import { Inject, Injectable } from "@angular/core";

import { ToolModel } from "../../../shared/entities/tool.model";
import { CustomerModel } from "../../../shared/entities/customer.model";
import { ClientModel } from "../../../shared/entities/client.model";
import { ENVIRONMENT } from "../../token";

@Injectable()
export class LocalStorageService {
	private adminToolStorageKey: string = "";
	private adminClientStorageKey: string = "";

	constructor(@Inject(ENVIRONMENT) protected environment) {
		this.adminToolStorageKey = environment.currentAdminToolkey;
		this.adminClientStorageKey = environment.currentAdminClientkey;
	}

	private getAdminToolDataFromLocalStorage(): ToolModel {
		return new ToolModel().deserialize(JSON.parse(localStorage.getItem(this.adminToolStorageKey)!));
	}

	public getAdminCustomerData(): CustomerModel | undefined {
		return new CustomerModel().deserialize(JSON.parse(localStorage.getItem("customer")!));
	}

	private getAdminClientDataFromLocalStorage(): ClientModel {
		return new ClientModel().deserialize(JSON.parse(localStorage.getItem(this.adminClientStorageKey)!));
	}

	public setAdminToolData(tool: ToolModel): void {
		this.setAdminToolDataInLocalStorage(tool);
	}

	private setAdminToolDataInLocalStorage(tool: any): void {
		localStorage.setItem(this.adminToolStorageKey, JSON.stringify(tool));
	}

	private setAdminCustomerDataInLocalStorage(customer: any): void {
		localStorage.setItem("customer", JSON.stringify(customer));
	}

	private setAdminClientDataInLocalStorage(client: ClientModel): void {
		localStorage.setItem(this.adminClientStorageKey, JSON.stringify(client));
	}

	public setUserIdInLocalStorage(id: string): void {
		localStorage.setItem("user", id);
	}

	public getAdminToolData(): ToolModel | undefined {
		return this.getAdminToolDataFromLocalStorage() ? this.getAdminToolDataFromLocalStorage() : undefined;
	}

	public setAdminCustomerData(customer: CustomerModel): void {
		this.setAdminCustomerDataInLocalStorage(customer);
	}

	public setAdminClientData(client: ClientModel): void {
		this.setAdminClientDataInLocalStorage(client);
	}

	public getAdminClientData(): ClientModel | undefined {
		return this.getAdminClientDataFromLocalStorage() ? this.getAdminClientDataFromLocalStorage() : undefined;
	}

	public setLocalStorageData(name: string, object: any): void {
		localStorage.setItem(name, JSON.stringify(object));
	}

	// Get from localStage all info about user logged and return it
	public getUserToken(): boolean {
		return false;
	}
}
